import {
  ObjectOperatorType,
  OperatorType,
  TopExpression,
  Variable,
} from 'vet-bones/utils/queryBuilder';

export const getIdsByIri = (topExpression: TopExpression) => {
  const idsByIri: Record<string, Set<string>> = {};
  const addIdByIri = ({ id, iri }: Variable) => {
    if (!idsByIri[iri]) {
      idsByIri[iri] = new Set();
    }
    idsByIri[iri].add(id);
  };

  topExpression.expressions.forEach((subExpression) => {
    subExpression.expressions.forEach((expression) => {
      expression.filters.forEach((filter) => {
        addIdByIri(filter.subject);

        if (
          filter.operator.operatorType === OperatorType.DATATYPE &&
          filter.operator.comparison &&
          filter.comparisonSubject
        ) {
          addIdByIri(filter.comparisonSubject);
        }

        if (
          filter.operator.type === ObjectOperatorType.CONNECTED &&
          filter.value &&
          typeof filter.value !== 'string'
        ) {
          addIdByIri(filter.value);
        }
      });
    });
  });

  return idsByIri;
};
